import React, { useCallback, useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link, useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import { BASE_URL } from "../Pages/Config";
import axios from "axios";
import Cookies from "js-cookie";
import { formatDate } from "../components/dateUtils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CountdownTimer } from "./CountDownTimer";
import BuyerName from "./BuyerName";
import Swal from "sweetalert2";

export default function SettingMySellings() {
  const [showToast, setToastMessage] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [productslength, setProductsLength] = useState([]);
  const fetchProducts = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/all_selling_user_item.php?id=${userId}&t=${Date.now()}`
      );
      // console.log(response);

      if (response.data.success && Array.isArray(response.data.data)) {
        const now = new Date().getTime();
        const activeProducts = response.data.data.filter((product) => {
          const closingTime = new Date(product.closing_time).getTime();
          return closingTime > now; // sirf future me close hone wale products
        });
        setProducts(activeProducts);
        setProductsLength(activeProducts.length);
        //  console.log(activeProducts);
      } else {
        console.error("Unexpected API structure");
        setProducts([]);
      }
    } catch (error) {
      console.error("Failed to fetch products", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  // const deleteproduct = async (productId: number) => {
  //   // const confirmDelete = window.confirm("Are you sure you want to delete this product?");
  //   // if (!confirmDelete) return;

  //   console.log(productId);
  //   try {
  //     const response = await axios.get(
  //       `https://upsalon.in/bsi/testauction/delete_item.php?id=${productId}`
  //     );
  //     console.log(response);

  //     if (response.data.success) {
  //       toast.success("Product deleted successfully. !");
  //       setTimeout(() => {
  //         fetchProducts();
  //       }, 1500);
  //     } else {
  //       alert("Failed to delete product.");
  //     }
  //   } catch (error) {
  //     console.error("Delete error:", error);
  //     setToastMessage(
  //       "An error occurred while deleting the product. Try again Later"
  //     );
  //   }
  // };

  const Endbid = async (productId: number) => {
    // Ask for confirmation before ending bid
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will end the bid for this product!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, end it!",
    });

    if (!result.isConfirmed) return; // user cancelled

    try {
      const response = await axios.get(
        `${BASE_URL}/end_bid.php?id=${productId}`
      );
      console.log(response);

      if (response.data.success) {
        Swal.fire({
          title: "Bid Ended!",
          text: "Product bidding ended successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        setTimeout(() => {
          fetchProducts();
        }, 1500);
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Could not end product bidding.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("End bid error:", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while ending the product bidding. Try again later.",
        icon: "error",
      });
    }
  };

  const makedarft = async (productId: number) => {
    // Ask for confirmation before making draft
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This product will be moved to draft!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, draft it!",
    });

    if (!result.isConfirmed) return; // user cancelled

    console.log(productId);
    try {
      const response = await axios.get(
        `${BASE_URL}/make_draft.php?id=${productId}`
      );
      // console.log(response);

      if (response.data.success) {
        Swal.fire({
          title: "Drafted!",
          text: "Product moved to draft successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchProducts();
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Could not move product to draft.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Delete error:", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while moving the product to draft. Try again later.",
        icon: "error",
      });
    }
  };

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>

                <p>SELINGS</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 ">
              <div className="col-12">
                <h2>
                  {loading ? (
                    <b>Loading...</b>
                  ) : (
                    <b>
                      Selling {products.length}{" "}
                      {products.length < 1 ? "Item" : "Items"}
                    </b>
                  )}
                </h2>
              </div>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      key="loading"
                      className="loading-overlay"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "550px",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : products.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="No Data Found"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    products.map((product) => (
                      <div
                        key={product.id}
                        className="col-xl-4 col-lg-4 col-md-6 p-0 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="auction-card">
                          <div className="auction-card-img-wrap">
                            <div className="card-img">
                              <img
                                src={
                                  product.photo
                                    ? `${BASE_URL}/${product.photo
                                      .split(",")[0]
                                      .trim()}`
                                    : `${BASE_URL}/uploads/logo/icon.png`
                                }
                                alt={product.title}
                              />
                            </div>

                            {product.user_bid_amount <= 0 ? (
                              <ul
                                className="view-and-favorite-area"
                                style={{ opacity: "15" }}
                              >
                                <li>
                                  <span
                                    onClick={() => {
                                      makedarft(product.id);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      background: "white",
                                      padding: "10px 12px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    Move To Draft
                                  </span>
                                </li>
                                {/* <li style={{ marginTop: "20px" }}>
                                  <span
                                    onClick={() => {
                                      Endbid(product.id);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      background: "white",
                                      padding: "10px 12px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    End Bid
                                  </span>
                                </li> */}

                                {/* <li
                                style={{ marginTop: "25px", marginLeft: "5px" }}
                              >
                                <Link
                                  to={`/list-an-item-edit/${product.id}`}
                                  style={{
                                    background: "white",
                                    padding: "10px 12px",
                                    borderRadius: "50%",
                                    color: "green",
                                  }}
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      background: "white",
                                      padding: "10px 12px",
                                      borderRadius: "50%",
                                      color: "green",
                                    }}
                                  >
                                    <FaEdit
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </span>
                                </Link>
                              </li> */}
                              </ul>
                            ) : (
                              ""
                            )}
                            <CountdownTimer
                              closingTime={product.closing_time}
                            />
                          </div>

                          <Link
                            to={`/detail/${product.id}`}
                            className="card-img"
                          >
                            <div className="auction-card-content">
                              <p style={{ fontSize: "12px" }}>
                                {formatDate(product.closing_time)}
                              </p>
                              <h6>
                                <Link to={`/detail/${product.id}`}>
                                  {product.title}
                                </Link>
                              </h6>
                              <div className="details_buyer">
                                <h6>Item Id</h6>{" "}
                                <p>
                                  <b>#{product.id}</b>
                                </p>
                              </div>
                              <div className="details_buyer">
                                <h6>Seller</h6>{" "}
                                <p>
                                  <Link to={`/review/${product.user_id}`}>
                                    <BuyerName buyerId={product.user_id} />
                                  </Link>
                                </p>
                              </div>

                              <div className="details_buyer">
                                <h6>Top Bid</h6>{" "}
                                <p
                                  style={{
                                    color: "#ebc32f",
                                    fontWeight: "800",
                                  }}
                                >
                                  {product.current_price || product.buy_now} SAR
                                </p>
                              </div>

                              <div className="rate_btn">
                                <Link to={`/detail/${product.id}`}>
                                  <button>View Item</button>
                                </Link>
                              </div>
                              {/* <div className="price-and-code-area">
                              <div className="price">
                                <span>Current Bid at:</span>
                                <strong>
                                  ${" "}
                                  {product.current_price === ""
                                    ? product.auction_start_price
                                    : product.current_price}
                                </strong>
                              </div>
                              <div className="code">
                                <span> # {product.id}</span>
                              </div>
                            </div> */}
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}
      <ToastContainer />
      <Fotter />
    </>
  );
}
